import { createSelector } from "reselect";

const prefix = "material/selection";

const SET_MATERIAL_ID = `${prefix}/SET_MATERIAL_ID`;

export const setMaterialId = (id) => ({ type: SET_MATERIAL_ID, payload: id });

const baseSelector = (state) => state.materialSelection;

export const getMaterialId = createSelector(baseSelector, (state) => state);

export default function materialSelection(state = null, action) {
  switch (action.type) {
    case SET_MATERIAL_ID:
      return action.payload;

    default:
      return state;
  }
}
